import React, { Component } from 'react';
import firebase from 'firebase';
import Modal from 'react-modal';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Alert from 'react-s-alert';


const database = firebase.database();

const customStyles = {
  content : {
    top                   : '75%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


class Modal_Vehiculos extends Component {
	
	constructor(){
		
		super();
		this.state={
		    socios:[],
			isActiveSocios:false,
			isActiveBases:false,
			bases:[],
			conductores:[],
			tipo_vehiculo:'',
			marca:'',
			modelo:'',
			anio:'',
			placa:'',
			capacidad:'',
			foto:'',
			disponibilidad:'',
			codigo_socio:'',
			estado:'',
			urlFoto:'',
			uploadValue:0,
			files:null,
			base:'',
			nodoBase:''
			
		};
		
		this.handleUpload=this.handleUpload.bind(this);
		this.handleSubmit=this.handleSubmit.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.basesRef=database.ref().child('Bases');
		this.empleadosRef=database.ref().child('Vehiculos');
		this.sociosRef=database.ref().child('Socios');
		this.handleKeyPressLetras=this.handleKeyPressLetras.bind(this);
		this.handleKeyPressNumeros=this.handleKeyPressNumeros.bind(this);
		this.handleClickBases=this.handleClickBases.bind(this);
		
		
	}
	
	componentWillMount(){
		
		Modal.setAppElement('body');
	}
	
	componentDidMount(){
		
		this.sociosRef.on('value',this.gotDataSocios,this.errDataSocios);
		this.basesRef.on('value',this.gotDataBases,this.errDataBases);
		
	}
	
	
		gotDataSocios=(data) =>{
		let newsocios = []
		const sociosdata = data.val();
		const keys = Object.keys(sociosdata);

		for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
	

			if(sociosdata[k].Estado!=='Inactivo'){
				
				newsocios.push({
				  key:k,
				  nombre:sociosdata[k].Nombre,
				  apellido:sociosdata[k].Apellido,
				  estado:sociosdata[k].Estado

				});			


			
			}

	
			
		 }
		this.setState({socios: newsocios});
	}
	errDataSocios = (err)=>{
		
		console.log(err);
		
	}

	
		gotDataBases = (data) => {
		
		
		  let newBase = [];
		  const basedata = data.val();
		  const keys = Object.keys(basedata);

		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
			newBase.push({
			  key:k,
			  nombre:basedata[k].Nombre,
			  descripcion:basedata[k].Descripcion,
			  foto:basedata[k].foto,
			  latitud:basedata[k].latitud,
			  longitud:basedata[k].longitud,
			  direccion:basedata[k].direccion
			});
		  }
		  this.setState({bases: newBase});
		}
		errDataBases = (err) => {
			console.log(err);
		}

	toggleModal=()=>{
		
		this.setState({
			isActive:!this.state.isActive,
			foto:null,
			uploadValue:0
		})
	}	
	
	toggleModalSocios=()=>{
		this.setState({
			
			isActiveSocios:!this.state.isActiveSocios
			
		})
	}
	
	toggleModalBases=()=>{
		
		this.setState({
			
			isActiveBases:!this.state.isActiveBases
			
		})
		
		
	}
	
	handleSubmit(event){
		
		
		
		let archivo=this.state.files;
		const storageRef = firebase.storage().ref(`Vehiculos/${archivo.name}`);
		
		const task= storageRef.put(archivo);
		
		task.on('state_changed', snapshot =>{
		
		
		this.setState({
		  uploadValue :50,
		})

		}, error =>{ console.log(error.message);
		},
		()=>{
			


			this.empleadosRef.push({
			
					tipo_vehiculo:this.tipoVehiculo.value,
					marca:this.marcaVehiculo.value,
					modelo:this.modeloVehiculo.value,
					anio:this.anioVehiculo.value,
					placa:this.placaVehiculo.value,
					capacidad:this.capacidadVehiculo.value,
					foto:task.snapshot.downloadURL,
					codigo_socio:firebase.auth().currentUser.uid,
					estado:this.estadoVehiculo.value,
					base:this.state.nodoBase
		   
			});	
	
			
			this.setState({
				uploadValue:100,
				urlFoto:task.snapshot.downloadURL
			});
			
			this.toggleModal();
			
			Alert.success('Datos guardados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000			
			});
			 

		});
	
		
	
		event.preventDefault();
	
	}
	
	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);	
		}	
	}
	
	handleClick=(rowKey)=>{
		
		this.setState({
			isActiveSocios:!this.state.isActiveSocios
		})
		
		
		this.socioKey.value=rowKey.key;
		this.socioVehiculo.value=rowKey.nombre+' '+rowKey.apellido; 
		
	}
	
	handleClickBases=(rowKey)=>{
		
		
		this.baseKey.value=rowKey.nombre;
		this.state.nodoBase=rowKey.key;
		
		this.toggleModalBases();
		
	}
	
	
	btnSoiciosFormatter(cell,row) {

		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Seleccionar</button>;
	}
	
	btnBasesFormatter(cell,row){
		
		
		return <button className="btn btn-success btn-sm" onClick={() => {this.handleClickBases(row)}} >Seleccionar</button>;
	}
	
	
	handleKeyPressLetras(e){
		
		let tecla=e.which;
		
		let patron =/^[a-zA-Z]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs && tecla!=32){			
			e.preventDefault();		
		}	
	}
	
	handleKeyPressNumeros(e){
	
		let tecla=e.which;		
		let patron =/^[0-9]+$/;
		let tecla_final = String.fromCharCode(tecla);
		
		let rs=patron.test(tecla_final);
		
		if(!rs){
			e.preventDefault();		
		}
	
	}
	
	
  render() {
    return (
		
		
		<div className="ingreso_vehiculos">
			
			
			<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
			
			
			<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >				
				<h3>Agregar Vehiculo</h3>
				<hr/>
	
				
				<form method="POST" action="" onSubmit={this.handleSubmit}>
					
					<div className="form-group">
						<label htmlFor="marca">Marca</label>
						<input type="text" name="marca" className="form-control"
						placeholder="Marca" required autoComplete="off"
						ref={input => {this.marcaVehiculo=input;}}
						onKeyPress={this.handleKeyPressLetras}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="modelo">Modelo</label>
						<input type="text" name="modelo" className="form-control"
						placeholder="Modelo" required autoComplete="off"
						ref={input => {this.modeloVehiculo=input;}}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="anio">Año</label>			
						<input type="text" name="anio" className="form-control"
						placeholder="Año" required autoComplete="off"
						ref={input => {this.anioVehiculo=input;}}
						onKeyPress={this.handleKeyPressNumeros}
						maxLength="4" minLength="4"
						/>
					</div>
				
					<div className="form-group">
						<label htmlFor="placa">Placa</label>
						<input type="text" name="placa" className="form-control"
						placeholder="Placa" required autoComplete="off"
						ref={input => {this.placaVehiculo=input;}}
						/>
					</div>
					<div className="form-group">
						<label htmlFor="capacidad">Capacidad</label>
						<input type="text" name="capacidad" className="form-control"
						placeholder="Capacidad" required autoComplete="off"
						ref={input => {this.capacidadVehiculo=input;}}
						onKeyPress={this.handleKeyPressNumeros}
						maxLength="2"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="tipo_vehiculo">Tipo Vehiculo</label>
						<select name="tipo_vehiculo" className="form-control"
						ref={input => {this.tipoVehiculo=input;}}
						>
							<option value="Taxi">Taxi</option>
							<option value="Privado">Privado</option>
							<option value="Microbus">Microbus</option>
							
						</select>
					</div>
					
					
					
					<div className="form-group">
						<label htmlFor="base">Base</label>
						<input type="text" className="form-control" 
						ref={input => {this.baseVehiculo=input;}}
						readOnly="readOnly" required autoComplete="off"
						placeholder="Elije una base" 
						onClick={this.toggleModalBases}
						ref={input =>{this.baseKey=input;}}
						
						/>
					</div>
					
					
					<div className="form-group">
						<label htmlFor="estado">Estado</label>
						<select name="estado" className="form-control"
						ref={input => {this.estadoVehiculo=input;}}
						>
							<option value="Disponible">Disponible</option>
							<option value="Asignado">Asignado</option>
						</select>
					</div>
					
					<div className="form-group">
						<label htmlFor="foto">Fotografia del vehiculo</label>
						<br/>
						<progress value={this.state.uploadValue} max="100"></progress>
						<input type="file" className="form-control"  onChange={this.handleUpload} required/>
					</div>
					<div className="image">
						<img src={this.state.foto} className="foto"  width="250px;" alt="foto vehiculo"/>
					</div>
					<br/>
					<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
						
						
				</form>	
			</Modal>
			
			<Modal isOpen={this.state.isActiveSocios} onRequestClose={this.toggleModalSocios}  style={customStyles}>
						<h4>Selecciona un socio</h4>
						<hr/>
					
					<BootstrapTable data={ this.state.socios}
						 ref='table'
						 pagination={ true }
						 search={ true }
						 hover
						 >
						 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>
						 <TableHeaderColumn dataField='apellido' dataSort={true}  >Apellido</TableHeaderColumn>
						 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnSoiciosFormatter.bind(this) }>Seleccionar</TableHeaderColumn>
					</BootstrapTable>					
			</Modal>
					
			<Modal isOpen={this.state.isActiveBases} onRequestClose={this.toggleModalBases} style={customStyles}>
						<h4>Selecciona una base</h4>
						<hr/>
						<BootstrapTable data={ this.state.bases}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='nombre' dataSort={true}  >Nombre</TableHeaderColumn>						
							 <TableHeaderColumn dataField='direccion' dataSort={true}  >Direccion</TableHeaderColumn>							 
							 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnBasesFormatter.bind(this) }>Seleccionar</TableHeaderColumn>
						</BootstrapTable>
						
						
			</Modal>
			
			
			
		</div>
    );
  }
}

export default Modal_Vehiculos;



// WEBPACK FOOTER //
// ./src/Components/Perfil_Socios/modal_vehiculos.js